import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const loadAnalytics = () => {
    const w = window as any;
    if (w.__analyticsLoaded) return;
    w.__analyticsLoaded = true;

    // Microsoft Clarity
    w.clarity = w.clarity || function (...args: unknown[]) {
      (w.clarity.q = w.clarity.q || []).push(args);
    };
    const c = document.createElement("script");
    c.async = true;
    c.src = "https://www.clarity.ms/tag/wj68fk8zj1";
    document.head.appendChild(c);

    // Google Analytics 4
    const g = document.createElement("script");
    g.async = true;
    g.src = "https://www.googletagmanager.com/gtag/js?id=G-VFZNK1RB9M";
    document.head.appendChild(g);
    w.dataLayer = w.dataLayer || [];
    w.gtag = function (...args: unknown[]) { w.dataLayer.push(args); };
    w.gtag("js", new Date());
    w.gtag("config", "G-VFZNK1RB9M", { send_page_view: false, currency: "EUR" });
  };

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "accepted");
    loadAnalytics();
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie-consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-3 md:p-6 animate-in slide-in-from-bottom-4 duration-500">
      <div className="container mx-auto max-w-4xl">
        <div className="backdrop-blur-md bg-card/95 rounded-2xl p-4 md:p-8 border border-border shadow-xl">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-6">
            <div className="hidden md:block flex-shrink-0 p-3 rounded-full bg-primary/10">
              <Cookie className="w-6 h-6 text-primary" />
            </div>
            
            <div className="flex-1 space-y-1">
              <p className="text-sm text-muted-foreground leading-relaxed">
                Naudojame slapukus patogesnei patirčiai.{" "}
                <Link 
                  to="/privatumo-politika" 
                  className="text-primary hover:underline font-medium"
                >
                  Privatumo politika
                </Link>
              </p>
            </div>

            <div className="flex flex-row gap-2 w-full md:w-auto">
              <Button
                variant="outline"
                size="sm"
                onClick={declineCookies}
                className="text-xs flex-1 md:flex-none"
              >
                Tik būtinieji
              </Button>
              <Button
                size="sm"
                onClick={acceptCookies}
                className="text-xs flex-1 md:flex-none"
              >
                Sutinku ✨
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
